import core from "@/core/index";
import store from "@/store";
import CodeService from "@/services/code/code.service";

class FacilityService {
  create(params) {
    const strParam = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .postJson(`/api/facility`, strParam)
        .then((data) => {
          if (data.facility) {
            resolve(data.facility);
          } else {
            reject({
              message: "not found item",
            });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  update(id, params) {
    const strParam = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .putJson(`/api/facility/${id}`, strParam)
        .then((data) => {
          if (data.facility) {
            resolve(data.facility);
          } else {
            reject({
              message: "not found item",
            });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  generatorAuthKey(id) {
    return new Promise((resolve, reject) => {
      core.http
        .patch(`/api/facility/${id}/auth-key`)
        .then((data) => {
          if (data.facility) {
            resolve(data.facility);
          } else {
            reject({
              message: "not found item",
            });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  delete(id) {
    return new Promise((resolve, reject) => {
      core.http
        .delete(`/api/facility/${id}`)
        .then((data) => {
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  getList() {
    return new Promise(async (resolve, reject) => {
      const cropCodeList = await CodeService.getCropCodeList();
      core.http
        .getJson(`/api/facility`, { ignoreAlertModal: true })
        .then((data) => {
          if (data.facilityList) {
            const facilityList = data.facilityList;
            facilityList.forEach((facility) => {
              facility.inFacilityList.forEach((inFacility) => {
                facility.cropCode = inFacility.cropCode;
                facility.dongType = inFacility.kindCode;
              });
              for (let i = 0; i < cropCodeList.length; i++) {
                if (facility.cropCode === cropCodeList[i].code) {
                  facility.cropName = cropCodeList[i].koName;
                }
              }
              facility.dongSize = facility.inFacilityList.length;
              facility.value = facility.id;
              facility.label = facility.name;
            });
            resolve(facilityList);
            store.commit("updateFacilityList", facilityList);
          } else {
            reject({
              message: "not found item",
            });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }
}

export default new FacilityService();
